//@ts-nocheck
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { FormElement } from "./types";
import { Switch } from "@headlessui/react";
import { JobApplicationFormContext } from "./JobApplicationFormContext";
import { CrossIcon } from "../../icons/Icons";
import { useAppSelector } from "../../../app/hooks";
import {
  closeFormAside,
  selectElementSteps,
} from "../../../features/questionSteps/questionStepSlice";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { RootState } from "../../../app/store";
import { useJobApplicationContext } from "../../application/JobApplicationContext";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";

interface FormBuilderProps {
  elements: FormElement[];
  setElements: React.Dispatch<React.SetStateAction<FormElement[]>>;
  index?: number;
  setIsFormAsideOpen: React.Dispatch<React.SetStateAction<boolean>>;
  error?: string;
  onSubmit: (e: any) => Promise<void>;
  isSaving: boolean;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const JobApplicationFormBuilder: React.FC<FormBuilderProps> = ({
  elements,
  setElements,
  error,
  onSubmit,
  isSaving,
}) => {
  const [editingState, setEditingState] = useState<{
    id: string | null;
    field: keyof FormElement | null;
  }>({ id: null, field: null });
  const [editingValue, setEditingValue] = useState<string>("");
  const [newOptionLabel, setNewOptionLabel] = useState("");
  const [editingOptionId, setEditingOptionId] = useState<string | null>(null);
  const { isFormAsideOpen, isFormAsideView, selectedElement } = useAppSelector(
    (state: RootState) => state.questionSteps,
  );
  const [enabled, setEnabled] = useState(
    selectedElement?.question_mandatory === "yes",
  );
  const [enabled1, setEnabled1] = useState(false);
  const [rating, setRating] = React.useState<number>(0);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedSmiley, setSelectedSmiley] = useState<string | null>(null);
  const [selectedThumb, setSelectedThumb] = useState<number | null>(null);
  const { updateElementMandatory } = useContext(JobApplicationFormContext);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [elementToDelete, setElementToDelete] = useState<string | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [editingDescriptionState, setEditingDescriptionState] = useState<{
    id: string | null;
    field: keyof FormElement | null;
  }>({ id: null, field: null });
  const [editingDescriptionValue, setEditingDescriptionValue] =
    useState<string>("");
  const [editingOptionId1, setEditingOptionId1] = useState<string | null>(null);
  // const [isHovered, setIsHovered] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>("yes");
  const {
    isAddingStep,
    setIsAddingStep,
    isReorderSelection,
    setIsReorderSelection,
  } = useJobApplicationContext();

  useEffect(() => {
    setEnabled(selectedElement?.question_mandatory === "yes");
  }, [selectedElement]);

  const handleMandatoryToggle = (elementId) => {
    const newStatus = !enabled;
    setEnabled(newStatus);
    updateElementMandatory(elementId, newStatus);

    setElements((prevElements) =>
      prevElements.map((element) =>
        element.id === elementId
          ? { ...element, is_mandatory: newStatus }
          : element,
      ),
    );
  };
  const dispatch = useDispatch();
  const handleEdit = (id: string, value: string, field: keyof FormElement) => {
    setEditingState({ id, field });
    setEditingValue(value);
  };

  const handleEdit1 = (id: string, des: string) => {
    setEditingDescriptionState({ id, field: "Description" });
    setEditingDescriptionValue(des);
  };
  const handleStepDelete = (id: string) => {
    setElementToDelete(id);
    setDeleteModalOpen(true);
  };

  // Modified confirmDelete function to include loading state
  const confirmDelete = () => {
    if (elementToDelete) {
      setIsDeleting(true);
      setTimeout(() => {
        setElements((prevElements) => {
          const updatedElements = prevElements.filter(
            (element) => element.id !== elementToDelete,
          );
          return updatedElements;
        });
        setEditingState({ id: null, field: null });
        setEditingDescriptionState({ id: null, field: null });
        setIsDeleting(false);
        setDeleteModalOpen(false);
        setElementToDelete(null);
      }, 500); // 1 second delay
    }
  };

  const handleStepView = useCallback(
    (id: string) => {
      setIsAddingStep(false);
      setIsReorderSelection(false);
      const element = elements.find((step) => step.id === id);
      if (element) {
        dispatch(selectElementSteps({ id, element }));
      }
    },
    [elements, dispatch],
  );

  const handleSave = () => {
    if (editingState.id && editingState.field) {
      setElements((prevElements) => {
        const updatedElements = prevElements.map((element) => {
          if (element.id === editingState.id) {
            const updatedElement = { ...element };
            if (editingState.field === "options") {
              updatedElement.options = editingValue
                .split(",")
                .map((option) => option.trim());
            } else {
              updatedElement[editingState.field] = editingValue;
            }

            return updatedElement;
          }
          return element;
        });

        return updatedElements;
      });

      setEditingState({ id: null, field: null });
      setEditingValue("");
    }
  };

  const handleSave1 = () => {
    if (editingDescriptionState.id) {
      setElements((prevElements) => {
        const updatedElements = prevElements.map((element) => {
          if (element.id === editingDescriptionState.id) {
            return { ...element, Description: editingDescriptionValue };
          }
          return element;
        });
        return updatedElements;
      });

      setEditingDescriptionState({ id: null, field: null });
      setEditingDescriptionValue("");
    }
  };

  const handleOptionClick = (elementId: string, optionId: number) => {
    setElements((prevElements) =>
      prevElements.map((element) =>
        element.id === elementId
          ? {
              ...element,
              options: element.options?.map((option) =>
                option.id === optionId
                  ? { ...option, selected: !option.selected }
                  : option,
              ),
            }
          : element,
      ),
    );
  };

  const handleRemoveOption = (elementId: string, optionId: number) => {
    setElements((prevElements) =>
      prevElements.map((element) => {
        if (element.id === elementId) {
          // Use element.options (the local item), NOT selectedElement.options
          const updatedOptions = (element.options || []).filter(
            (opt) => opt.id !== optionId,
          );
          const updatedElement = { ...element, options: updatedOptions };

          // Sync Redux ONLY if this is the one currently open in the sidebar
          if (selectedElement?.id === elementId) {
            dispatch(
              selectElementSteps({ id: elementId, element: updatedElement }),
            );
          }
          return updatedElement;
        }
        return element;
      }),
    );
  };

  const handleAddOption = (elementId: string) => {
    setElements((prevElements) =>
      prevElements.map((element) => {
        if (element.id === elementId) {
          // Use element.options (the local item), NOT selectedElement.options
          const updatedOptions = [
            ...(element.options || []),
            { id: uuidv4(), label: "New Option", selected: false },
          ];
          const updatedElement = { ...element, options: updatedOptions };

          if (selectedElement?.id === elementId) {
            dispatch(
              selectElementSteps({ id: elementId, element: updatedElement }),
            );
          }
          return updatedElement;
        }
        return element;
      }),
    );
  };

  const handleSidebarSectionChange = (id: string, newSection: string) => {
    const updatedElement = { ...selectedElement, section: newSection };

    setElements((prev) =>
      prev.map((el) => (el.id === id ? updatedElement : el)),
    );

    dispatch(
      selectElementSteps({
        id,
        element: updatedElement,
      }),
    );
  };

  const handleAddOption1 = (elementId: string) => {
    setElements((prevElements) =>
      prevElements.map((element) =>
        element.id === elementId
          ? {
              ...element,
              options: [
                ...(element.options || []),
                { id: uuidv4(), label: "No.", selected: false },
              ],
            }
          : element,
      ),
    );
  };

  const handleOptionEdit = (
    elementId: string,
    optionId: string,
    label: string,
  ) => {
    setEditingOptionId(optionId);
    setEditingValue(label);
    setEditingDescriptionValue(label);
  };

  const handleOptionSave = (elementId: string) => {
    if (editingOptionId) {
      setElements((prevElements) =>
        prevElements.map((element) =>
          element.id === elementId
            ? {
                ...element,
                options: element.options?.map((option) =>
                  option.id === editingOptionId
                    ? { ...option, label: editingValue }
                    : option,
                ),
              }
            : element,
        ),
      );

      setEditingOptionId(null);
      setEditingValue("");
      setEditingDescriptionValue("");
    }
  };

  const textareaRef1 = useRef(null);
  const textareaRef2 = useRef(null);

  useEffect(() => {
    if (textareaRef1.current) {
      textareaRef1.current.style.height = "0px";
      const scrollHeight = textareaRef1.current.scrollHeight;

      textareaRef1.current.style.height = `${scrollHeight}px`;
    }
  }, [newOptionLabel]);

  useEffect(() => {
    if (textareaRef2.current) {
      textareaRef2.current.style.height = "0px";
      const scrollHeight = textareaRef2.current.scrollHeight;
      textareaRef2.current.style.height = `19 +${scrollHeight}px`;
    }
  }, [newOptionLabel]);

  const handleSidebarUpdate = (
    id: string,
    field: keyof FormElement,
    value: string,
  ) => {
    setElements((prev) =>
      prev.map((el) => (el.id === id ? { ...el, [field]: value } : el)),
    );

    dispatch(
      selectElementSteps({
        id,
        element: { ...selectedElement, [field]: value },
      }),
    );
  };

  const handleSidebarOptionLabelUpdate = (
    elementId: string,
    optionId: string,
    newLabel: string,
  ) => {
    setElements((prev) =>
      prev.map((el) => {
        if (el.id === elementId) {
          const updatedOptions = (el.options || []).map((opt) =>
            opt.id === optionId ? { ...opt, label: newLabel } : opt,
          );
          const updatedElement = { ...el, options: updatedOptions };

          if (selectedElement?.id === elementId) {
            dispatch(
              selectElementSteps({ id: elementId, element: updatedElement }),
            );
          }
          return updatedElement;
        }
        return el;
      }),
    );
  };

  // New helper to show clean list view on the canvas
  const renderCanvasItem = (element: FormElement, index: number) => {
    const isSelected = selectedElement?.id === element.id;
    const displayText = element.label || element.type || "No Value";
    const currentSection = element.section || "question";

    return (
      <div className="flex items-start gap-2 p-2">
        <div className="flex flex-col gap-y-2 w-full">
          <div className="flex items-center gap-x-1">
            <span
              className="cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md bg-gray-50 px-2 
           text-gray-600 ring-1 ring-inset ring-gray-500/10 w-fit py-0"
            >
              {displayText
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
            </span>{" "}
            <span
              className="cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md bg-gray-50 px-2 
           text-gray-600 ring-1 ring-inset ring-gray-500/10 w-fit py-0"
            >
              Section: {element.section || "question"}
            </span>
            {element?.question_mandatory === "yes" && (
              <span className="text-red-500 ">*</span>
            )}
          </div>
          {/* <div className="flex flex-col">
            <label className="text-[13px] font-medium text-gray-400">
              Question Text
            </label>
            <p className="cursor-pointer font-[400] text-[#121217] text-[14px] flex items-center">
              {element.headerText || (
                <span className="text-gray-300 italic">Untitled Question</span>
              )}
            </p>
          </div>

          {element.instructions && (
            <p className="text-[12px] text-gray-500 line-clamp-2">
              {element.instructions}
            </p>
          )} */}
          <div className="flex flex-col gap-0.5">
            <label className="text-[11px] font-base text-gray-400 uppercase tracking-tight">
              Question
            </label>

            <p className=" font-medium text-gray-900 line-clamp-2">
              {element.headerText}
            </p>
          </div>

          {/* 3. Instructions Input */}
          {element.instruction && (
            <div className="flex flex-col gap-0.5">
              <label className="text-[11px] font-base text-gray-400 uppercase tracking-tight">
                Instructions
              </label>
              <p className="text-[14px] text-gray-500 line-clamp-2">
                {element.instruction}
              </p>
            </div>
          )}

          {[
            "radio",
            "checkbox",
            "single_select",
            "multi_select",
            "rating",
          ].includes(element.type) && (
            <div className="flex flex-col gap-3 w-full ">
              <div className="flex items-center justify-between">
                <label className="text-[13px] font-medium text-gray-700">
                  Options
                </label>
                <button
                  onClick={() => handleAddOption(element.id)}
                  className="text-[11px] font-semibold text-indigo-600 hover:text-indigo-500"
                >
                  + Add Option
                </button>
              </div>

              <div className="space-y-2 max-h-[300px] overflow-y-auto pr-1 custom-scrollbar">
                {element?.options?.map((option, index) => (
                  <div
                    key={option.id}
                    className="flex items-center gap-2 group"
                  >
                    <div className="flex-grow relative">
                      <input
                        type="text"
                        value={option.label}
                        onChange={(e) =>
                          handleSidebarOptionLabelUpdate(
                            element.id,
                            option.id,
                            e.target.value,
                          )
                        }
                        className="block w-full rounded-md border-0 py-1 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-[12px]"
                        placeholder={`Option ${index + 1}`}
                      />
                    </div>
                    <button
                      onClick={() => handleRemoveOption(element.id, option.id)}
                      className="text-gray-400 hover:text-red-500"
                    >
                      <CrossIcon />
                    </button>
                    {/* <button
                      onClick={() => handleRemoveOption(element.id, option.id)}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </button> */}
                  </div>
                ))}
              </div>

              {element.options?.length === 0 && (
                <p className="text-[12px] text-gray-400 italic text-center py-2">
                  No options added yet.
                </p>
              )}
            </div>
          )}
        </div>
        <div className="w-4 h-4" onClick={() => handleStepView(element.id)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="w-[15px] text-[#758482]"
          >
            <path
              fillRule="evenodd"
              d="M8.34 1.804A1 1 0 0 1 9.32 1h1.36a1 1 0 0 1 .98.804l.295 1.473c.497.144.971.342 1.416.587l1.25-.834a1 1 0 0 1 1.262.125l.962.962a1 1 0 0 1 .125 1.262l-.834 1.25c.245.445.443.919.587 1.416l1.473.294a1 1 0 0 1 .804.98v1.361a1 1 0 0 1-.804.98l-1.473.295a6.95 6.95 0 0 1-.587 1.416l.834 1.25a1 1 0 0 1-.125 1.262l-.962.962a1 1 0 0 1-1.262.125l-1.25-.834a6.953 6.953 0 0 1-1.416.587l-.294 1.473a1 1 0 0 1-.98.804H9.32a1 1 0 0 1-.98-.804l-.295-1.473a6.957 6.957 0 0 1-1.416-.587l-1.25.834a1 1 0 0 1-1.262-.125l-.962-.962a1 1 0 0 1-.125-1.262l.834-1.25a6.957 6.957 0 0 1-.587-1.416l-1.473-.294A1 1 0 0 1 1 10.68V9.32a1 1 0 0 1 .804-.98l1.473-.295c.144-.497.342-.971.587-1.416l-.834-1.25a1 1 0 0 1 .125-1.262l.962-.962A1 1 0 0 1 5.38 3.03l1.25.834a6.957 6.957 0 0 1 1.416-.587l.294-1.473ZM13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <div className="w-4 h-4" onClick={() => handleStepDelete(element.id)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="w-[15px] text-[#758482]"
          >
            <path
              fillRule="evenodd"
              d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
    );
  };

  const renderElement = (element: FormElement, index: number) => {
    return renderCanvasItem(element, index);
  };

  return (
    <div className="flex-1 p-0">
      <div className="">
        {elements.map((element, index) => (
          <div key={index} className="px-1">
            {renderElement(element, index)}
          </div>
        ))}
      </div>
      <div
        className="flex flex-col min-w-[200px] bg-white z-10 absolute lg:fixed right-0 max-w-[80%] view-feedback-right-side"
        style={{
          width: isFormAsideOpen ? "351px" : "350px",
          marginRight: isFormAsideOpen ? "8px" : "-400px",
          top: isFormAsideOpen ? "60px" : "0px",
          height: isFormAsideOpen ? "calc(100vh - 70px)" : "100%",
          ...(window.innerWidth <= 768 && {
            width: isFormAsideOpen ? "300px" : "300px",
            marginRight: isFormAsideOpen ? "0" : "-300px",
          }),
        }}
      >
        {/* Flex container for the whole sidebar */}
        <div className="flex flex-col h-full border border-light-gray-200 border-solid mt-[5px] rounded-md overflow-hidden">
          {/* Header - Fixed at top */}
          <div className="flex items-center justify-between p-6 border-b border-gray-100">
            <p className="text-wedges-gray text-lg font-medium">Manage Step</p>
            <button
              type="button"
              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
              onClick={() => dispatch(closeFormAside())}
            >
              <span className="sr-only">Close</span>
              <CrossIcon />
            </button>
          </div>

          {selectedElement ? (
            <>
              {/* Scrollable Body Content */}
              <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">
                <div className="flex flex-col gap-5">
                  {/* Badge Type */}
                  <div>
                    <p className="cursor-auto font-normal text-[13px] capitalize inline-flex items-center rounded-md bg-gray-50 px-2 text-gray-600 ring-1 ring-inset ring-gray-500/10 w-fit py-0">
                      {(
                        selectedElement?.label ||
                        selectedElement?.type ||
                        "No Value"
                      )
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase())}
                    </p>
                  </div>

                  {/* Question Type Listbox */}
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[13px] font-medium text-gray-700">
                      Question Type
                    </label>
                    <Listbox
                      value={selectedElement.section || "question"}
                      onChange={(value) =>
                        handleSidebarSectionChange(selectedElement.id, value)
                      }
                    >
                      <div className="relative">
                        <ListboxButton className="relative w-full rounded-md bg-white py-1.5 px-3 text-left text-gray-900 focus:outline-none text-[12px] border border-solid border-[#e7e7e8] font-medium">
                          <div className="flex items-center justify-between">
                            <span className="block truncate capitalize text-gray-600">
                              {selectedElement.section || "question"}
                            </span>
                            <svg
                              className="size-3"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="m19.5 8.25-7.5 7.5-7.5-7.5"
                              />
                            </svg>
                          </div>
                        </ListboxButton>
                        <ListboxOptions className="absolute z-20 mt-1 w-full bg-white rounded-lg border border-border shadow-lg p-1">
                          {["profile", "skill", "question"].map((sec) => (
                            <ListboxOption
                              key={sec}
                              value={sec}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-indigo-50 text-indigo-600"
                                    : "text-gray-900",
                                  "relative flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-[12px]",
                                )
                              }
                            >
                              <span className="block truncate capitalize font-normal">
                                {sec}
                              </span>
                            </ListboxOption>
                          ))}
                        </ListboxOptions>
                      </div>
                    </Listbox>
                  </div>

                  {/* Question Text Input */}
                  <div className="flex flex-col gap-1.5">
                    <div className="flex justify-between items-center">
                      <label className="text-[13px] font-medium text-gray-700">
                        Question Text
                      </label>
                      <span className="text-[11px] text-gray-400">
                        {(selectedElement.headerText || "").length}/50
                      </span>
                    </div>
                    <input
                      type="text"
                      value={selectedElement.headerText || ""}
                      maxLength={50}
                      onChange={(e) => {
                        const newValue = e.target.value.slice(0, 50);
                        handleSidebarUpdate(
                          selectedElement.id,
                          "headerText",
                          newValue,
                        );
                      }}
                      placeholder="Enter your question here"
                      className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 text-[13px] focus:ring-2 focus:ring-indigo-600"
                    />
                  </div>

                  {/* Options Manager */}
                  {[
                    "radio",
                    "checkbox",
                    "single_select",
                    "multi_select",
                    "rating",
                  ].includes(selectedElement.type) && (
                    <div className="flex flex-col gap-3 w-full border-t border-gray-100 pt-4">
                      <div className="flex items-center justify-between">
                        <label className="text-[13px] font-medium text-gray-700">
                          Options
                        </label>
                        <button
                          onClick={() => handleAddOption(selectedElement.id)}
                          className="text-[11px] font-semibold text-indigo-600"
                        >
                          + Add Option
                        </button>
                      </div>
                      <div className="space-y-2">
                        {selectedElement?.options?.map((option) => (
                          <div
                            key={option.id}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="text"
                              value={option.label}
                              onChange={(e) =>
                                handleSidebarOptionLabelUpdate(
                                  selectedElement.id,
                                  option.id,
                                  e.target.value,
                                )
                              }
                              className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 text-[13px] focus:ring-2 focus:ring-indigo-600"
                            />
                            <button
                              onClick={() =>
                                handleRemoveOption(
                                  selectedElement.id,
                                  option.id,
                                )
                              }
                              className="text-gray-400 hover:text-red-500"
                            >
                              <CrossIcon />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Instructions */}
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[13px] font-medium text-gray-700">
                      Instructions (Optional)
                    </label>
                    <textarea
                      rows={3}
                      value={selectedElement.instruction || ""}
                      onChange={(e) =>
                        handleSidebarUpdate(
                          selectedElement.id,
                          "instruction",
                          e.target.value,
                        )
                      }
                      className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 text-[13px] focus:ring-2 focus:ring-indigo-600"
                    />
                  </div>

                  {/* Is Mandatory Toggle */}
                  <div className="flex items-center justify-between py-4 border-t border-gray-100">
                    <div className="font-normal text-dark-black-200 text-[13px]">
                      Is Mandatory
                    </div>
                    <Switch
                      checked={enabled}
                      onChange={() => handleMandatoryToggle(selectedElement.id)}
                      className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
                    >
                      <span className="pointer-events-none absolute mx-auto h-4 w-9 rounded-full bg-gray-200 group-data-[checked]:bg-indigo-600" />
                      <span className="pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow transition-transform group-data-[checked]:translate-x-5" />
                    </Switch>
                  </div>
                </div>
              </div>

              {/* Footer - Save Button stays at the bottom */}
              <div className="p-6 border-t border-gray-100 bg-gray-50">
                <button
                  type="button"
                  onClick={onSubmit}
                  disabled={isSaving}
                  className="w-full inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none disabled:opacity-50"
                >
                  <div className="flex items-center gap-2">
                    {isSaving ? "Saving..." : "Save Changes"}
                    {isSaving && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </div>
                </button>
              </div>
            </>
          ) : (
            <div className="p-6 text-center text-gray-400 italic text-sm">
              Select a step to manage
            </div>
          )}
        </div>
      </div>
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        className="relative z-10"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:ml-0 sm:mt-0 sm:text-left">
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Delete Step
                    </DialogTitle>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Are you sure you want to delete this step?
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" px-4 py-3 sm:flex gap-x-2 sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  className="group flex shrink-0  gap-x-2 select-none  justify-center items-center px-[14px] text-[13px] font-medium h-[32px] leading-6 transition-colors
                                    duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                                     py-[4px] rounded-md text-white outline-indigo-600
                                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                  onClick={confirmDelete}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <>
                      Delete
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </>
                  ) : (
                    "Delete"
                  )}
                </button>
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-[14px] py-2 text-[13px] leading-6 items-center font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setDeleteModalOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default JobApplicationFormBuilder;
